import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import robot from './robot.png';
import Logo from '@icons/logo';

import './not-found.scss';

const NotFoundPage = ({publicPage = false}) => (
  <main styleName="page-not-found-container">
    <img src={robot} alt="" />
    <h1 styleName="page-not-found-header">
      404 Error - Page Not Found
    </h1>
    <div styleName="page-not-found-body">
      Sorry, the page you are looking for could not be found.
    </div>
    {publicPage ?
      <Logo /> :
      <Link to="/">
        <Logo title="Go to main page"/>
      </Link>
    }
  </main>
);

NotFoundPage.propTypes = {
  publicPage: PropTypes.bool
};

export default NotFoundPage;
